import { Dayjs } from "dayjs"

export enum EmailTemplateSender {
  NOVA = "Nova",
  JUNIFER = "Junifer",
  EXTERNAL = "External",
}

export interface ICommunication {
  id: number
  name: string
  communicationType: string
}

/** The version-dropdown contract, satisfied by internal and external templates. */
export interface IEmailTemplateVersionOption {
  id: number
  version: number
  isLive: boolean
  createdAt: Dayjs | null
}

export interface IEmailTemplateSummary {
  id: number
  communicationId: number
  version: number
  isLive: boolean
  subject: string
  createdAt: Dayjs | null
  publishedAt: Dayjs | null
  modifiedBy: string | null
  communication: ICommunication
}

export interface IEmailTemplate extends IEmailTemplateSummary {
  plainContent: string
  htmlContent: string
  modifiedReason: string | null
}

export enum SyncEnvironment {
  STAGING = "staging",
  PRODUCTION = "production",
}

/** A version carried between staging and production, which share no API. */
export interface IEmailTemplateSyncPayload {
  communicationName: string
  subject: string
  htmlContent: string
  plainContent: string
  modifiedReason: string | null
  makeLive: boolean
  sourceEnvironment: SyncEnvironment
}

export interface ICreateEmailTemplateInput {
  communicationId: number
  version: number
  isLive: boolean
  subject: string
  plainContent: string
  htmlContent: string
  modifiedBy: string | null
  modifiedReason: string | null
}
